module.exports = __webpack_public_path__ + "media/images/icons/email-7dfa0b9737b09606ec14c885dafcc0b8.svg";